import { useState, useEffect } from 'react';

export interface LLMModel {
  id: number;
  model_name: string;
  deployment: string;
  sdk_type: string;
  max_tokens: number;
  cost_prompt: number;
  cost_completion: number;
  description: string;
}

const useGetAvailableModels = () => {
  const [data, setData] = useState<LLMModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const API_URL = process.env.REACT_APP_LIST_AVAILABLE_MODELS_API || '';

  const refetch = () => setRefreshKey((k) => k + 1);

  useEffect(() => {
    if (!API_URL) return;

    const fetchModels = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch models: ${response.status}`);
        }
        const models: LLMModel[] = await response.json();
        setData(models);
      } catch (err) {
        console.error('Error fetching available models:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch models');
      } finally {
        setLoading(false);
      }
    };

    fetchModels();
  }, [API_URL, refreshKey]);

  return { data, loading, error, refetch };
};

export default useGetAvailableModels;
